/** Schmale Hülle um fetch: schickt und liest JSON, wirft mit lesbarem Text. */
async function request(method, url, body) {
  let res;
  try {
    res = await fetch(url, {
      method,
      credentials: "same-origin",
      headers: body === undefined ? undefined : { "Content-Type": "application/json" },
      body: body === undefined ? undefined : JSON.stringify(body),
    });
  } catch {
    throw new Error("Keine Verbindung zum Server. Bitte die Internetverbindung prüfen.");
  }

  const text = await res.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = null;
  }

  if (!res.ok) {
    const err = new Error(data?.error || "Da ist etwas schiefgelaufen. Bitte nochmals versuchen.");
    err.status = res.status;
    throw err;
  }
  return data;
}

/** Bild roh hochladen – der Inhaltstyp der Datei ist zugleich der Kopfeintrag. */
async function upload(file) {
  let res;
  try {
    res = await fetch("/api/admin/uploads", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": file.type || "application/octet-stream" },
      body: file,
    });
  } catch {
    throw new Error("Keine Verbindung zum Server. Bitte nochmals versuchen.");
  }

  const text = await res.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = null;
  }
  if (!res.ok) {
    const err = new Error(data?.error || "Das Logo liess sich nicht hochladen.");
    err.status = res.status;
    throw err;
  }
  return data;
}

export const api = {
  site: () => request("GET", "/api/site"),
  apply: (form) => request("POST", "/api/applications", form),

  session: () => request("GET", "/api/admin/session"),
  signIn: (password) => request("POST", "/api/admin/session", { password }),
  signOut: () => request("DELETE", "/api/admin/session"),

  adminData: () => request("GET", "/api/admin/data"),

  createEvent: (ev) => request("POST", "/api/admin/events", ev),
  updateEvent: (ev) => request("PUT", `/api/admin/events/${ev.id}`, ev),
  deleteEvent: (id) => request("DELETE", `/api/admin/events/${id}`),

  createMember: (m) => request("POST", "/api/admin/members", m),
  updateMember: (m) => request("PUT", `/api/admin/members/${m.id}`, m),
  deleteMember: (id) => request("DELETE", `/api/admin/members/${id}`),

  uploadLogo: (file) => upload(file),

  saveBenefits: (benefits) => request("PUT", "/api/admin/benefits", { benefits }),

  setApplicationStatus: (id, status) => request("PUT", `/api/admin/applications/${id}`, { status }),
  acceptApplication: (id) => request("POST", `/api/admin/applications/${id}/accept`),
  deleteApplication: (id) => request("DELETE", `/api/admin/applications/${id}`),

  saveSettings: (settings) => request("PUT", "/api/admin/settings", settings),
  changePassword: (current, next) => request("PUT", "/api/admin/password", { current, next }),
  backup: () => request("POST", "/api/admin/backup"),
};
